module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-google-recaptcha/~/babel-runtime/core-js/object/assign.js
// module id = 678
// module chunks = 0